import axiosInstance from "./axiosInstance";

// GET /api/posts/{id}/
export const getPostById = async (postId) => {
  const response = await axiosInstance.get(`/posts/${postId}/`);
  return response.data;
};